<script setup lang="ts">
import AsideContent from './AsideContent.vue'
import listIcon from '~/assets/images/user/vip/icon-list.png'
import createSearch from '~/assets/images/user/vip/icon-search.png'
import rankingIcon from '~/assets/images/user/vip/icon-rank.png'
import detailIcon from '~/assets/images/user/vip/icon-detail.png'
import exportIcon from '~/assets/images/user/vip/icon-export.png'
import bloggerIcon from '~/assets/images/user/vip/icon-blogger.png'
import bloggerContactIcon from '~/assets/images/user/vip/icon-blogger-cantact.png'
import collectIcon from '~/assets/images/user/vip/icon-collect.png'
import filterIcon from '~/assets/images/user/vip/icon-filter.png'

const props = defineProps<{
  data: any
}>()
const { t } = useI18n()
const privilege = computed(() => {
  const isResource2 = props.data?.resource === 2
  return [
    {
      icon: listIcon,
      name: t('列表数据'),
      desc: isResource2 ? t('vip.upTo', [2000]) : t('vip.不限'),
    },
    {
      icon: createSearch,
      name: t('搜索次数'),
      desc: t('vip.不限'),
    },
    {
      icon: rankingIcon,
      name: t('榜单数据'),
      desc: isResource2 ? t('vip.top', [500]) : t('vip.top', [1000]),
    },
    {
      icon: detailIcon,
      name: t('查看详情'),
      desc: t('90天数据'),
    },
    {
      icon: exportIcon,
      name: t('数据导出'),
      desc: isResource2 ? `100${t('次/月')}` : `500${t('次/月')}`,
    },
    {
      icon: isResource2 ? bloggerIcon : bloggerContactIcon,
      name: isResource2 ? t('达人导出') : t('达人邮箱'),
      desc: isResource2 ? t('vip.export', [200]) : t('vip.export', [1000]),
    },
    {
      icon: collectIcon,
      name: t('我的收藏'),
      desc: isResource2 ? t('vip.upTo1', [600]) : t('vip.upTo1', [2000]),
    },
    {
      icon: filterIcon,
      name: t('高级筛选'),
      desc: t('vip.不限'),
    },
  ]
})
</script>

<template>
  <div box-border min-h-516 w-232 rd-12 p-24 class="g-user__vip--aside">
    <div class="flex flex-col gap-24">
      <div
        class="text-16 text-[--color-text-1] font-600"
        v-html="`${$t('vip.vipPrivilege',
                      [`<span class='mx-2 text-[--color-brand-6]'>${data.resource === 2 ? 33 : 36}</span>`,
                       $t(`vip.${data?.resource === 2 ? '专业版' : '企业版'}`)])}`"
      />
      <AsideContent :resource="data?.resource" :privilege="privilege" />
      <div class="text-center text-[--color-text-4]">
        {{ $t('完整权益请查看对比表格') }}
      </div>
      <!-- <a-button
        type="outline" shape="round"
        style="border: 1px solid var(--color-fill-3); color: var(--color-text-2);"
      >
        全部权益
      </a-button> -->
    </div>
  </div>
</template>

<style lang="less" scoped>
.g-user__vip--aside {
  background: linear-gradient(185deg, #FEF7F7 -15.28%, #F4F3FF 49.52%, #F5F3FF 52.41%, #FFF 93.6%);
}
.g-vip__icon {
  background: linear-gradient(239deg, rgba(255, 255, 255, 0.00) -40.17%, rgba(233, 225, 255, 0.50) 100%), rgba(255, 255, 255, 0.40);
  box-shadow: 0px 4px 8px 0px #FFF inset, 0px 0px 4px 0px #FFF inset;
  backdrop-filter: blur(2px);
}
</style>
